// src/config/menuConfig.js

export const MENUS = [
  { 
    id: 'dashboard', 
    title: 'TODAY', 
    roles: ['ADMIN', 'STAFF', 'VIEWER'] // 리콜수행자 제외
  },
  { 
    id: 'customer', 
    title: '고객 관리', 
    roles: ['ADMIN', 'STAFF'] 
  },
  { 
    id: 'vehicle', 
    title: '차량 관리', 
    roles: ['ADMIN', 'STAFF'] 
  },
  { 
    id: 'as', 
    title: 'AS 관리', 
    roles: ['ADMIN', 'STAFF'] 
  },
  { 
    id: 'recall', 
    title: '리콜 관리', 
    roles: ['ADMIN', 'STAFF', 'RECALL'] // 리콜수행자는 이것만 가능
  },
  { 
    // ★ 복구 완료: 부품 관리 메뉴가 다시 추가되었습니다.
    id: 'part', 
    title: '부품 관리', 
    roles: ['ADMIN', 'STAFF'] 
  },
  { 
    // 🚀 [아이콘 제거] 다른 메뉴들과 디자인 톤앤매너 매칭을 위해 텍스트만 깔끔하게 정돈
    id: 'analysis', 
    title: '데이터 분석', 
    roles: ['ADMIN', 'STAFF', 'VIEWER'] 
  },
  { 
    id: 'system', 
    title: '시스템 설정', 
    roles: ['ADMIN'] // 오직 마스터(ADMIN)만 가능
  }
];